/**
 * ReelDisplayData.ts
 */
export class ReelDisplayData {
    constructor(numberOfReels) {
        this.numberOfReels = numberOfReels;
    }
    reset() {
        this.startIndex = 0;
        this.stopIndex = 0;
    }
    spin() {
        this.startIndex++;
    }
    stopReel() {
        this.stopIndex++;
    }
    isStopReady() {
        return this.isStartComplete();
    }
    isStartComplete() {
        return this.startIndex >= this.numberOfReels;
    }
    isStopComplete() {
        //Logger.debug("STOP INDEX: " + this.stopIndex);
        return this.stopIndex >= this.numberOfReels;
    }
    hasDisableIndex(value) {
        return this.disabledIndexes.indexOf(value) >= 0;
    }
    getStartIndex() {
        return this.startIndex;
    }
    getStopIndex() {
        return this.stopIndex;
    }
    setIntroSequence(value) {
        this.introSequence = value;
    }
    setDarkenedReels(value) {
        this.darkenedReels = value;
    }
    setDisabledIndexes(value) {
        this.disabledIndexes = value;
    }
    setDisplaySymbols(value) {
        this.displaySymbols = value;
    }
    getIntroSequence() {
        return this.introSequence;
    }
    getDisabledIndexes() {
        return this.disabledIndexes;
    }
    getDisplaySymbols() {
        return this.displaySymbols;
    }
    getStopSymbol() {
        return this.displaySymbols[this.stopIndex];
    }
    getDarkenedReels() {
        return this.darkenedReels;
    }
    getNumberOfReels() {
        return this.numberOfReels;
    }
}
//# sourceMappingURL=ReelDisplayData.js.map